import { TipoEspacioI } from "interfaces/TipoEspacio";

export interface infoFetchGetTipoEspacioI {
  id: number | string;
  nombre: string;
  con_sub_tipo: boolean;
}

class TipoEspacio implements TipoEspacioI {
  id: number | string;
  nombre: string;
  con_sub_tipo: boolean;

  constructor(dto: infoFetchGetTipoEspacioI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.con_sub_tipo = dto.con_sub_tipo;
  }
}

export const makeTipoEspacio = (infoFetch: infoFetchGetTipoEspacioI) => {
  return new TipoEspacio(infoFetch);
};
